/* eslint-disable @typescript-eslint/camelcase */
/* global $ */
import React from 'react'
import ReactDOM from 'react-dom'
import intl from 'react-intl-universal'
import { hasPermission } from '../services/permission'
import * as pubstackApi from '../../api/story'
import {
  composeWebsitesFromCirculations,
  normalizeAnsFromCirculations,
} from '~/reactapp/App/CirculateTab/CirculateTab.utils'
import {
  setCirculation as setCirculationsRedux,
  getCirculation,
  getDocument,
  getScheduleStatus,
  getStoryData,
} from '~/redux/storyData'
import denormalizer from '~/reactapp/story/util/denormalizer'
import CanonicalUrl from '../../reactapp/App/CanonicalUrl'

function canonicalUrlController(
  toastr,
  contentApi,
  $scope,
  $rootScope,
  getErrorMessage,
  $ngRedux,
  $timeout
) {
  let reactCanonicalUrl
  this.intl = intl
  this.enabled = false
  this.fetching = false
  this.duplicatedWarning = false
  this.websiteIdToRegenerateUrlFor = null
  this.proposedUrl = ''
  this.modalPromptedMessage = intl.get('canonicalUrl.modal.proposed.prompt') // default message
  this.isRegerateAllUrlEnabled = true

  const ngReduxUnsubscribe = $ngRedux.connect((state) => ({
    document: getDocument(state),
    circulations: getCirculation(state),
    scheduleStatus: getScheduleStatus(state),
    storyData: getStoryData(state),
  }))(this)

  this.hasRegeneratePermissions =
    hasPermission(window.userRolesAuth.story.urlRegeneration) &&
    hasPermission(window.userRolesAuth.story.circulate)

  $scope.$watch('vm.circulations', (newVal) => {
    /**
     * This if is needed in case the user clicks
     * Publish and to refresh the component with
     * websites URL
     */
    if (reactCanonicalUrl !== undefined) {
      ReactDOM.unmountComponentAtNode(reactCanonicalUrl)

      if (newVal.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        renderRegenAllComponent(newVal)
      }
    }
    this.websitesObj = composeWebsitesFromCirculations(newVal)
  })

  // This is needed to re-render the Regen All component after scheduling/unscheduling a story
  $scope.$watch('vm.scheduleStatus', () => {
    if (reactCanonicalUrl !== undefined) {
      ReactDOM.unmountComponentAtNode(reactCanonicalUrl)

      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      renderRegenAllComponent(this.circulations)
    }
  })

  /**
   * We need to put a watch over the storyData change,
   * once is changes, we can check if we should re-render the component.
   *
   * If is re-rendered, it will disable all the regenerate buttons
   */
  $scope.$watch('vm.storyData', () => {
    if (this.isRegerateAllUrlEnabled && reactCanonicalUrl !== undefined) {
      ReactDOM.unmountComponentAtNode(reactCanonicalUrl)

      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      renderRegenAllComponent(this.circulations)
    }
  })

  const onPublishedOrScheduled = ($event, { storyObj }) => {
    this.websitesObj = storyObj.websites
    this.storyObj.canonical_url = storyObj.canonical_url
    this.storyObj.first_publish_date = storyObj.first_publish_date
    this.storyObj.websites = storyObj.websites
  }

  let unsubscribePublishfn = $rootScope.$on(
    'STORY_PUBLISHED',
    onPublishedOrScheduled
  )
  let unsubscribeSchedulefn = $rootScope.$on(
    'STORY_SCHEDULED',
    onPublishedOrScheduled
  )

  $scope.$on('$destroy', () => {
    if (unsubscribePublishfn) {
      unsubscribePublishfn()
      unsubscribePublishfn = null
    }

    if (unsubscribeSchedulefn) {
      unsubscribeSchedulefn()
      unsubscribeSchedulefn = null
    }

    ngReduxUnsubscribe()

    ReactDOM.unmountComponentAtNode(reactCanonicalUrl)
  })

  const testUrlSuccess = (response) => {
    const websiteUrl = response
    this.proposedUrl = websiteUrl
    const test = this.proposedUrl.match(/(-\d+)\/?$/)
    this.urlEnding = test ? test[1] : ''
    this.duplicatedWarning = this.urlEnding && this.urlEnding.length > 0
  }

  const testUrlFailure = (errorMessage) => {
    // console.log(errorMessage);
    $('#regenerateCanonicalUrlModal').modal('hide')
    toastr.error(
      intl.get('canonicalUrl.regen.error', {
        msg: errorMessage,
      }),
      intl.get('common.error'),
      { timeOut: 20000 }
    )
  }

  this.test = async (websiteId) => {
    this.fetching = true
    this.websiteIdToRegenerateUrlFor = websiteId

    $('#regenerateCanonicalUrlModal').modal('show').css('display', 'flex')

    this.modalPromptedMessage = this.document.published_revision_id
      ? `${intl.get('canonicalUrl.modal.proposed.prompt')} ${intl.get(
          'canonicalUrl.modal.proposed.note'
        )}`
      : `${intl.get('canonicalUrl.modal.proposed.prompt')}`

    const {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      website_url,
      // Omit website_url to trigger URL (re)generation
      ...circulationNoUrl
    } = this.circulations.find(
      (circ) => circ.website_id === this.websiteIdToRegenerateUrlFor
    )

    try {
      let websiteUrl = ''

      if (this.document.published_revision_id) {
        const dryRunCirculation = await pubstackApi.saveCirculation(
          circulationNoUrl,
          {
            collision_behavior: 'increment',
            dryrun: 'true',
          }
        )
        websiteUrl = dryRunCirculation.website_url
      } else {
        // Regenerating a preview URL generated after first schedule
        const normalizedAns = normalizeAnsFromCirculations(
          this.storyObj,
          this.circulations,
          new Date(this.scheduleStatus.publish)
        )
        if (!normalizedAns) {
          toastr.error(intl.get('errorReasons.websiteURLsGenerationFailure'), {
            timeOut: 20000,
          })
          console.error('Failed to normalize ANS from circulations.')
          return
        }
        const [ans] = await denormalizer([normalizedAns]).catch((error) => {
          console.error(
            'Failed to denormalize ANS before generating preview URLs',
            error
          )
          return normalizedAns
        })
        const resolveUrlResult = await pubstackApi.resolveUrl(
          circulationNoUrl.website_id,
          circulationNoUrl.document_id,
          ans
        )
        websiteUrl = resolveUrlResult.website_url
      }

      testUrlSuccess(websiteUrl)
    } catch (error) {
      testUrlFailure(
        error.errorData ? error.errorData.error_message : error.message
      )
    } finally {
      this.fetching = false
    }
  }

  this.regen = () => {
    const onReject = (reason) => {
      toastr.error(
        intl.get('canonicalUrl.regen.error', {
          msg: getErrorMessage(reason, 'Error while generating canonical URL'),
        }),
        {
          timeOut: 20000,
        }
      )
    }

    const circulationIndex = this.circulations.findIndex(
      (circ) => circ.website_id === this.websiteIdToRegenerateUrlFor
    )
    const updatedCirculation = {
      ...this.circulations[circulationIndex],
      website_url: this.proposedUrl,
    }

    $(`#${this.websiteIdToRegenerateUrlFor}-regen-button`)
      .removeClass('btn-outline-primary')
      .addClass('btn-is-regenerating')
      .attr('disabled', 'true')

    pubstackApi
      .saveCirculation(updatedCirculation, {
        collision_behavior: 'increment',
      })
      .then(
        (circulation) => {
          toastr.clear()
          const tostrMessage = this.document.published_revision_id
            ? intl.get('canonicalUrl.regen.success.circulationToNewUrl')
            : intl.get('canonicalUrl.regen.success.circulationSaved')
          toastr.success(tostrMessage)

          const updatedCirculations = [...this.circulations]
          updatedCirculations.splice(circulationIndex, 1, circulation)

          $ngRedux.dispatch(setCirculationsRedux(updatedCirculations))

          $(`#${this.websiteIdToRegenerateUrlFor}-regen-button`)
            .removeClass('btn-is-regenerating')
            .addClass('btn-outline-primary')
            .removeAttr('disabled')
        },
        (error) => {
          onReject(error)
        }
      )
  }

  const renderRegenAllComponent = (circulations) => {
    if (this.isRegerateAllUrlEnabled) {
      $timeout(() => {
        reactCanonicalUrl = document.getElementById('canonical-url')
        ReactDOM.render(
          <CanonicalUrl
            websitesObj={this.websitesObj}
            storyObj={this.storyObj}
            handleSingleRegeneration={this.test}
            hasRegeneratePermissions={this.hasRegeneratePermissions}
            circulations={circulations}
            isScheduled={!!this.scheduleStatus.publish}
          />,
          reactCanonicalUrl
        )
      })
    }
  }

  this.$postLink = () => {
    if (this.circulations.length > 0) {
      renderRegenAllComponent(this.circulations)
    }
  }
}

export default [
  'toastr',
  'contentApiService',
  '$scope',
  '$rootScope',
  'getErrorMessage',
  '$ngRedux',
  '$timeout',
  canonicalUrlController,
]
